var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicaLicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.8926C0.453651 22.3108 3.36503 24.9448 6.89022 24.9448C10.4154 24.9448 13.3263 22.3079 13.78 18.8926H0Z",
    fill: "url(#paint0_linear_440_3354)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.78 17.0283C13.3263 13.6101 10.4149 10.9766 6.89022 10.9766C3.36552 10.9766 0.454139 13.612 0 17.0283H13.78Z",
    fill: "url(#paint1_linear_440_3354)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4308 16.1396L22.1845 10.7988C20.0244 10.9237 17.9022 11.4216 15.912 12.2706C15.3378 12.5141 14.7798 12.7839 14.2381 13.0798C15.2214 14.5732 15.7306 16.3289 15.6989 18.1167C15.6672 19.9045 15.096 21.6411 14.0603 23.0987C14.9507 24.0077 16.0943 24.6273 17.3421 24.8766C18.5898 25.1259 19.8837 24.9934 21.055 24.4963C24.2843 23.1255 25.7981 19.384 24.4308 16.1396V16.1396Z",
    fill: "url(#paint2_linear_440_3354)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2805 3.89615C17.9162 0.652223 14.1917 -0.866458 10.9625 0.50475C7.73318 1.87547 6.22182 5.61699 7.58668 8.8614L7.70779 9.15C9.71313 9.33687 11.5928 10.209 13.0305 11.6194C13.7287 11.2234 14.449 10.8678 15.1879 10.5544C17.1703 9.70869 19.2733 9.17958 21.4199 8.98641L19.2805 3.89615ZM17.2389 5.83381C17.1265 5.88104 17.006 5.90569 16.8842 5.90634C16.7623 5.90699 16.6415 5.88364 16.5287 5.83762C16.4159 5.79159 16.3133 5.72379 16.2266 5.6381C16.14 5.5524 16.0711 5.45048 16.0239 5.33816C15.8438 4.9048 15.5658 4.51898 15.2118 4.21088C14.8578 3.90277 14.4373 3.68074 13.9832 3.56213C13.7469 3.49784 13.5457 3.34276 13.4233 3.1307C13.3009 2.91863 13.2672 2.66678 13.3298 2.43003C13.3923 2.19329 13.5458 1.99085 13.7569 1.86684C13.9681 1.74284 14.2197 1.70732 14.4569 1.76804C15.186 1.95828 15.8612 2.31455 16.4298 2.80902C16.9984 3.30348 17.4449 3.92273 17.7345 4.61837C17.7818 4.73072 17.8065 4.85129 17.8072 4.97318C17.8079 5.09508 17.7846 5.21592 17.7385 5.3288C17.6925 5.44167 17.6247 5.54437 17.5389 5.63102C17.4532 5.71768 17.3512 5.78658 17.2389 5.83381V5.83381Z",
    fill: "url(#paint3_linear_440_3354)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_440_3354",
    x1: 13.78,
    y1: 18.8926,
    x2: 6.58847,
    y2: 36.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9DFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85DDDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_440_3354",
    x1: 13.78,
    y1: 10.9766,
    x2: 6.58947,
    y2: 28.9719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9DFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85DDDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_440_3354",
    x1: 24.9343,
    y1: 10.7988,
    x2: 0.809831,
    y2: 31.1028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9DFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85DDDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_440_3354",
    x1: 21.4199,
    y1: 5.94399e-7,
    x2: 2.28057,
    y2: 25.9534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9DFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85DDDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicaLicon);
export default __webpack_public_path__ + "static/media/MEDICALicon.d462c890eacf6aac0bca700d066c902b.svg";
export { ForwardRef as ReactComponent };